module.exports = __webpack_public_path__ + "img/3.caf20474.png";